import * as React from "react";
import {Spinner} from "react-bootstrap";
import { Loader } from "lucide-react";
import Callout from "Components/Common/Callout";

interface SnapshotProps {
    thumbUrl: string
    largeUrl: string
}

interface SnapshotState {
    thumbHasLoaded: boolean
    largeHasLoaded: boolean
    shouldShowCloseUp: boolean
    imgError: boolean
}

export class TicketSnapshot extends React.Component<SnapshotProps, SnapshotState> {

    state = {
        thumbHasLoaded: false,
        largeHasLoaded: false,
        shouldShowCloseUp: false,
        imgError: false
    };

    thumbElement: HTMLElement | null;

    handleThumbLoaded = () => {
        this.setState({thumbHasLoaded: true});
    };
    handleLargeLoaded = () => {
        this.setState({largeHasLoaded: true});
    };
    handleThumbError = () => {
        this.setState({imgError: true});
    };
    handleLargeError = () => {
        this.setState({imgError: true});
    };
    toggleCloseup = () => {
        this.setState({shouldShowCloseUp: !this.state.shouldShowCloseUp});
    };

    openSnapshotGallery = () => {
        this.toggleCloseup();
    };
    renderLargeDisplay = () => {
        return (
            <Callout onDismiss={ this.toggleCloseup } show={this.state.shouldShowCloseUp && !!this.thumbElement}>
                <div className="snapshot-closeup">
                    { this.state.largeHasLoaded ? <img style={{maxWidth: 1030, maxHeight: 950}} onClick={() => this.toggleCloseup()} src={this.props.largeUrl} alt="snapshot"/> : <Spinner animation={"border"} variant={"secondary"} className="green-spinner" /> }
                </div>
            </Callout>
        );
    };

    renderExpandButton = () => {
        return (
            <div className="expand-button" onClick={ this.openSnapshotGallery }>
                <svg viewBox="0 0 100 100" width="21px">
                    <path d="M25,2 L2,2 L2,25" fill="none" />
                    <path d="M2,75 L2,98 L25,98" fill="none" />
                    <path d="M75,98 L98,98 L98,75" fill="none" />
                    <path d="M98,25 L98,2 L75,2" fill="none" />
                </svg>
            </div>
        );
    };

    render () {
        const { thumbHasLoaded, largeHasLoaded, imgError } = this.state;
        return (
            <div className="snapshot-container">
                {this.renderExpandButton()}
                {!thumbHasLoaded && !imgError && (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 180 }}>
                        <Loader className="lucide-loader" size={36} strokeWidth={2.5} style={{ color: "#888", animation: "spin 1s linear infinite" }} />
                    </div>
                )}
                {imgError && (
                    <div style={{ color: "#c00", textAlign: "center", padding: 16 }}>
                        <span role="img" aria-label="broken image">🚫</span> Snapshot failed to load
                    </div>
                )}
                {thumbHasLoaded && !imgError ? (
                    <img
                        className="snapshot"
                        src={this.props.thumbUrl}
                        ref={thumb => (this.thumbElement = thumb)}
                        onLoad={this.handleThumbLoaded}
                        onError={this.handleThumbError}
                        alt={"thumb"}
                    />
                ) : null}
                {largeHasLoaded ? this.renderLargeDisplay() : null}
                <img style={{ display: "none" }} src={this.props.largeUrl} onLoad={this.handleLargeLoaded} onError={this.handleLargeError} alt="large snapshot" />
                <img style={{ display: "none" }} src={this.props.thumbUrl} onLoad={this.handleThumbLoaded} onError={this.handleThumbError} alt="thumb snapshot" />
            </div>
        );
    }

}